import { CEF, ETF, MONEY_MARKET_FUND, MUTUAL_FUND, SEPARATE_ACCOUNT, UIT, UNLISTED_CEF, } from 'NewAngular/constants/core.constants';
export const ENHANCED_BENCHMARK_VALUE = 'enhanced';
export const STANDARD_BENCHMARK_VALUE = 'standard';
export const CUSTOM_BENCHMARK_VALUE = 'custom';
export const ENHANCED_BENCHMARK_LABEL = 'YCharts Categorization';
export const STANDARD_BENCHMARK_LABEL = 'Broad Asset Class';
export const CUSTOM_BENCHMARK_LABEL = 'Custom';
export const SUPPORTED_ENHANCED_BENCHMARK_DETAILED_SECURITY_TYPES = [
    UNLISTED_CEF,
    CEF,
    ETF,
    MUTUAL_FUND,
    SEPARATE_ACCOUNT,
    UIT,
    MONEY_MARKET_FUND,
];
